import React from 'react'
import Airnb from "../../assets/svgs/SalesChannel/New_Sales/airbnb.svg"
import Booking from "../../assets/svgs/SalesChannel/New_Sales/booking.svg"
import Expedia from "../../assets/svgs/SalesChannel/New_Sales/expedia.svg"
import Trivago from "../../assets/svgs/SalesChannel/New_Sales/trivago.svg"
import Yolo from "../../assets/svgs/SalesChannel/Yolo.svg"
import CircleSmall from "../../assets/svgs/SalesChannel/CircleSmall.svg"
import CircleMedium from "../../assets/svgs/SalesChannel/CircleMedium.svg"
import CircleBig from "../../assets/svgs/SalesChannel/CircleBig.svg"


const SalesChannel = () => {
  return (
    <div style={{display:"flex",justifyContent:"center",backgroundColor:"rgba(255, 255, 255, 1)"}}>
        <div className='paddingDesktop' style={{ display: 'flex', width: '100%', maxWidth: '1340px', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{display:"flex",flexDirection:"column",alignItems:"center",padding:"35px 0 60px 0",backgroundColor:"rgba(255, 255, 255, 1)"}}>
            <div className='fz_title_components_owner' style={{textAlign:"center"}}>
            <span><span style={{color:"#FF3097"}}>Ampla divulgação</span> em canais de vendas</span>
            </div>
            <div className='fz_sub_title_components_owner'  style={{textAlign:"center"}}>
                <span>A gestão multicanais da Yolo otimiza vendas, unindo os principais canais globais de forma eficiente.

                </span>
            </div>

            <div style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center',paddingTop:"50px" }}>
                <div style={{ position: 'relative' }}>
                    <img src={CircleBig} alt="Circle Big" />
                    <div style={{ position: 'absolute', top: '0', left: '-25%', width: '50%', height: '50%',display:"flex", zIndex: '90' }}>
                        <img src={Expedia} alt="Expedia" style={{width:"100%",maxWidth:"100%"}} />
                    </div>
                    <div style={{ position: 'absolute', top: '0', right: '-20%', width: '50%', height: '50%',display:"flex", zIndex: '90' }}>
                        <img src={Airnb} alt="Airnb" style={{width:"100%",maxWidth:"100%"}} />
                    </div>
                    <div style={{ position: 'absolute', bottom: '0', left: '-25%', width: '50%', height: '50%',display:"flex", zIndex: '90' }}>
                        <img src={Booking} alt="Booking" style={{width:"100%",maxWidth:"100%"}} />
                    </div>
                    <div style={{ position: 'absolute', bottom: '0', right: '-20%', width: '50%', height: '50%',display:"flex", zIndex: '90' }}>
                        <img src={Trivago} alt="Trivago" style={{width:"100%",maxWidth:"100%"}} />
                    </div>
                    <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                        <img src={CircleMedium} alt="Circle Medium" style={{ width: "367.43px", height: "367.43px", maxWidth: "367.43px" }} />
                    <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -42%)' }}>
                        <img src={CircleSmall} alt="Circle Small"style={{ width: "275.57px", height: "275.57px", maxWidth: "275.57px" }}  />
                        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                        <img src={Yolo} alt="Yolo" />
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            </div>

            </div>
        </div>
  )
}

export default SalesChannel